function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M9.047 10.953A10.528 10.528 0 016.848 7.78a.624.624 0 01.139-.689l.682-.682c.56-.559.56-1.35.071-1.838l-.978-.978a1.666 1.666 0 00-2.357 0l-.543.543c-.618.617-.875 1.508-.709 2.392.412 2.177 1.677 4.561 3.718 6.602 2.04 2.041 4.425 3.306 6.602 3.718.884.166 1.774-.091 2.392-.709l.542-.542c.651-.651.651-1.706 0-2.357l-.977-.977a1.25 1.25 0 00-1.768 0l-.752.753a.624.624 0 01-.69.138 10.55 10.55 0 01-3.173-2.2z",
  stroke: "#000",
  strokeWidth: "1.3",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));